import { FormModel } from 'submodules/nerit-framework-ui/common/form-state-manager/types/FormModel'
import { IsOptional } from 'class-validator'
import { IFormStateManager } from 'submodules/nerit-framework-ui/common/form-state-manager/types/IFormStateManager'
import { MatrixSearchRequestDTO } from 'submodules/nerit-aquatec-sdk/services/matrix/dtos/requests/MatrixSearchRequestDTO'

export class MatrixFiltersFormModel extends FormModel {

    @IsOptional()
    searchString?: string

    constructor(initialData?: Partial<MatrixFiltersFormModel>) {
        super(initialData)
        Object.assign(this, initialData)
    }

    static formatDto(formStateManager: IFormStateManager<MatrixFiltersFormModel>): MatrixSearchRequestDTO {

        if (!formStateManager.getFormValues())
            return {}

        return {
            searchString: formStateManager.getFormValues()!.searchString,
        }
    }

}
